import io from "socket.io-client";
import { API_BASE_URL } from "../../config";
import {
  fetchBondDiceHistory,
  fetchBondDiceInvestors,
  fetchBondDiceLanding,
  fetchBondDicePlayers,
  fetchBondDicePool,
  setBondDiceLastSettled,
  setBondDicePendingRound,
} from "./bondDiceSlice";

let socket = null;
let initialized = false;

export const initBondDiceSocket = (dispatch) => {
  if (initialized && socket?.connected) return socket;
  initialized = true;

  if (!socket) {
    socket = io(API_BASE_URL, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 30000,
      upgrade: false,
      forceNew: false,
      withCredentials: false,
    });
  }

  socket.off("connect");
  socket.off("bond-dice:round:pending");
  socket.off("bond-dice:round:settled");
  socket.off("bond-dice:pool:update");
  socket.off("bond-dice:investors:update");
  socket.off("bond-dice:players:update");

  socket.on("connect", () => {
    dispatch(fetchBondDiceLanding());
    dispatch(fetchBondDicePool());
    dispatch(fetchBondDicePlayers({ limit: 100 }));
  });

  socket.on("bond-dice:round:pending", (round) => {
    dispatch(setBondDicePendingRound(round));
  });

  socket.on("bond-dice:round:settled", (round) => {
    dispatch(setBondDicePendingRound(null));
    dispatch(setBondDiceLastSettled(round));
    dispatch(fetchBondDicePool());
    dispatch(fetchBondDiceInvestors({ limit: 100 }));
    dispatch(fetchBondDicePlayers({ limit: 100 }));
    dispatch(fetchBondDiceHistory({ limit: 6 }));
  });

  socket.on("bond-dice:pool:update", () => {
    dispatch(fetchBondDicePool());
    dispatch(fetchBondDiceInvestors({ limit: 100 }));
    dispatch(fetchBondDicePlayers({ limit: 100 }));
  });

  socket.on("bond-dice:investors:update", () => {
    dispatch(fetchBondDiceInvestors({ limit: 100 }));
  });

  socket.on("bond-dice:players:update", () => {
    dispatch(fetchBondDicePlayers({ limit: 100 }));
  });

  if (!socket.connected) socket.connect();
  dispatch(fetchBondDiceLanding());
  dispatch(fetchBondDicePool());
  dispatch(fetchBondDicePlayers({ limit: 100 }));
  return socket;
};
